import { render, staticRenderFns } from "./B737V4.vue?vue&type=template&id=54186365&scoped=true&"
import script from "./B737V4.vue?vue&type=script&lang=js&"
export * from "./B737V4.vue?vue&type=script&lang=js&"
import style0 from "./B737V4.vue?vue&type=style&index=0&id=54186365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54186365",
  null
  
)

export default component.exports